import { render, staticRenderFns } from "./curriculumLessonDetail.vue?vue&type=template&id=f0241282&scoped=true"
import script from "./curriculumLessonDetail.vue?vue&type=script&lang=js"
export * from "./curriculumLessonDetail.vue?vue&type=script&lang=js"
import style0 from "./curriculumLessonDetail.vue?vue&type=style&index=0&id=f0241282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0241282",
  null
  
)

export default component.exports